import { cn } from '@/lib/utils';
import { TradeItem } from './TradeItemCard';
import { formatUsdCents } from '@/lib/formatMoney';

interface TradeSummaryProps {
  receivedItems: TradeItem[];
  gaveItems: TradeItem[];
  cashReceivedCents: number;
  cashPaidCents: number;
}

export function TradeSummary({
  receivedItems,
  gaveItems,
  cashReceivedCents,
  cashPaidCents,
}: TradeSummaryProps) {
  // Calculate totals
  const receivedItemsValue = receivedItems.reduce(
    (sum, item) => sum + (item.estimatedValueCents || 0), 
    0
  );
  const gaveItemsValue = gaveItems.reduce(
    (sum, item) => sum + (item.estimatedValueCents || 0), 
    0
  );

  const totalReceived = receivedItemsValue + cashReceivedCents;
  const totalGave = gaveItemsValue + cashPaidCents;
  const netValue = totalReceived - totalGave;

  const hasAnyValue = totalReceived > 0 || totalGave > 0;

  if (!hasAnyValue) return null;

  return (
    <div className="p-3 rounded-lg bg-black/30 border border-white/[0.08] space-y-2">
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">Received Value:</span>
        <span className="text-success">
          +{formatUsdCents(totalReceived)}
        </span>
      </div>
      
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">Gave Value:</span>
        <span className="text-destructive">
          -{formatUsdCents(totalGave)}
        </span>
      </div>
      
      <div className="flex justify-between text-sm font-medium border-t border-white/10 pt-2">
        <span>Net Value:</span>
        <span className={cn(
          netValue >= 0 ? "text-success" : "text-destructive"
        )}>
          {netValue >= 0 ? '+' : ''}{formatUsdCents(netValue)}
        </span>
      </div>
    </div>
  );
}
